<template>
  <ul
    :class="componentClass"
    :style="componentStyle"
  >
    <slot />
  </ul>
</template>

<script>
  export default {
    name: 'JumpToNavList',

    props: {
      hasDivider: {
        type: Boolean,
        default: false
      },
      customStyle: {
        type: Object,
        default: () => {}
      }
    },

    computed: {
      componentClass() {
        return ['nav-list', { 'padding-bottom-2xl': this.hasDivider }]
      },
      componentStyle() {
        let style = {}

        if (this.hasDivider) {
          style['--margin-bottom'] = 'var(--spacing-2xl)'
          style['border-bottom'] = '1px solid var(--white)'
        }

        return {
          ...style,
          ...{
            '--list-style-type': 'none',
            '--padding-left': '0'
          },
          ...this.customStyle
        }
      }
    }
  }
</script>
